import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from '../../../service/user.service';
import { TranslatePipe } from '@ngx-translate/core';
import { GameThemeService } from '../../../service/game-theme.service';
import { AchievementIconPipe } from '../../../pipe/achievement-icon-pipe';

export type UserAchievements = Record<string, boolean>;

@Component({
  selector: 'gandalf-achievements',
  standalone: true,
  imports: [CommonModule, TranslatePipe, AchievementIconPipe],
  templateUrl: './achievements.component.html',
  styleUrl: './achievements.component.scss',
})
export class AchievementsComponent { //implements OnInit {
  isInDialog = input<boolean>(false);
  showText = input<boolean>(true);
  allCompletedLevels = input<boolean>(false);

  protected readonly userService = inject(UserService);
  protected userAchievements = computed<UserAchievements>(() => this.userService.userAchievements() ?? {});
  protected currentLevel = computed<number>(() => this.userService.userLevel() ?? 1);
  protected readonly gameThemeService = inject(GameThemeService);
  protected readonly allAchievements = this.gameThemeService.getCurrentAchievements();

  constructor() {
    this.userService.getUserAchievements();
  }
}
